import { render, staticRenderFns } from "./LotteryMenu.vue?vue&type=template&id=1b1eb830&"
import script from "YD/components/lotteryMenu.component?vue&type=script&lang=js&"
export * from "YD/components/lotteryMenu.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports